<div class="task-closed rounded px-1">
  <div><strong>Task Closed</strong></div>
  <div>
    <p *ngIf="task.allCapturesHaveReferral">A valid referral has been collected for this patient.</p>
    <p *ngIf="!task.allCapturesHaveReferral">No referral has been collected for this patient.</p>
  </div>
</div>
